<!-- src/apps/secret/components/layout/BrandedHero.vue -->
<!-- secrets-files fork: hero branded compartido (logo o wordmark + título). -->

<script setup lang="ts">
  import { ref } from 'vue';
  import { useProductIdentity } from '@/shared/stores/identityStore';

  defineProps<{ title: string; subtitle?: string }>();

  const { logoUri, siteName, primaryColor, displayName } = useProductIdentity();

  // Oculta el logo si la imagen falla (404), cae al wordmark de texto.
  const imageError = ref(false);
</script>

<template>
  <div class="mb-8 text-center">
    <!-- Logo (si hay) -->
    <div
      v-if="logoUri && !imageError"
      class="mb-6 flex justify-center">
      <img
        :src="logoUri"
        class="h-16 max-w-[200px] object-contain"
        :alt="displayName"
        @error="imageError = true" />
    </div>

    <!-- Wordmark de marca (site_name) cuando no hay logo visible -->
    <p
      v-if="siteName && (!logoUri || imageError)"
      data-testid="branded-hero-site-name"
      class="mb-2 text-sm font-semibold uppercase tracking-wider"
      :style="{ color: primaryColor }">
      {{ siteName }}
    </p>

    <h1 class="text-2xl font-semibold text-gray-900 dark:text-white">
      {{ title }}
    </h1>
    <p
      v-if="subtitle"
      class="mt-2 text-gray-600 dark:text-gray-300">
      {{ subtitle }}
    </p>
  </div>
</template>
